module.exports = __webpack_public_path__ + "img/logo.578fee64.png";